import { render, staticRenderFns } from "./AddToCartDialog.vue?vue&type=template&id=410e162e"
import script from "./AddToCartDialog.vue?vue&type=script&lang=js"
export * from "./AddToCartDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('410e162e')) {
      api.createRecord('410e162e', component.options)
    } else {
      api.reload('410e162e', component.options)
    }
    module.hot.accept("./AddToCartDialog.vue?vue&type=template&id=410e162e", function () {
      api.rerender('410e162e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/AddToCartDialog.vue"
export default component.exports